// src/features/kommunikation/components/CustomerSelectionModal.tsx
import React from 'react';
import { Users, AlertTriangle, Building2 } from 'lucide-react';
import { Customer } from '../../../shared/types';
interface CustomerSelectionModalProps {
  isOpen: boolean;
  customers: Customer[];
  filename: string;
  onSelect: (customer: Customer) => void;
  onCancel: () => void;
}
export const CustomerSelectionModal: React.FC<CustomerSelectionModalProps> = ({
  isOpen,
  customers,
  filename,
  onSelect,
  onCancel
}) => {
  if (!isOpen) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2000
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '24px',
          maxWidth: '600px',
          width: '90%',
          maxHeight: '80vh',
          overflow: 'auto',
          border: '1px solid #E5E7EB',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
          <div style={{
            width: '36px', height: '36px', borderRadius: '8px',
            backgroundColor: '#3B82F615', display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            <Users size={18} color="#3B82F6" />
          </div>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#111827' }}>
            Kunde auswählen
          </h2>
        </div>

        {/* Hinweis */}
        <div style={{
          marginBottom: '16px',
          padding: '12px 14px',
          backgroundColor: '#FFFBEB',
          border: '1px solid #FDE68A',
          borderRadius: '8px',
          display: 'flex',
          gap: '10px',
          alignItems: 'flex-start'
        }}>
          <AlertTriangle size={18} color="#F59E0B" style={{ flexShrink: 0, marginTop: '1px' }} />
          <div>
            <div style={{ fontSize: '14px', fontWeight: '600', color: '#92400E', marginBottom: '2px' }}>
              Mehrere Kunden gefunden
            </div>
            <div style={{ fontSize: '13px', color: '#92400E' }}>
              Für die Datei <strong>{filename}</strong> wurden mehrere Kunden mit derselben Mandantennummer gefunden.
              Bitte wähle den richtigen Kunden aus:
            </div>
          </div>
        </div>

        {/* Kunden-Liste */}
        <div style={{ marginBottom: '16px' }}>
          {customers.map((customer) => (
            <button
              key={customer.id}
              onClick={() => onSelect(customer)}
              style={{
                width: '100%',
                padding: '14px 16px',
                marginBottom: '8px',
                border: '1px solid #E5E7EB',
                borderRadius: '10px',
                backgroundColor: 'white',
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'all 0.15s',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#3B82F6';
                e.currentTarget.style.backgroundColor = '#EFF6FF';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#E5E7EB';
                e.currentTarget.style.backgroundColor = 'white';
              }}
            >
              <div style={{
                width: '36px', height: '36px', borderRadius: '8px', flexShrink: 0,
                backgroundColor: '#F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
                <Building2 size={18} color="#6B7280" />
              </div>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontWeight: '600', fontSize: '15px', color: '#111827', marginBottom: '2px' }}>
                  {customer.company}
                </div>
                <div style={{ fontSize: '13px', color: '#6B7280' }}>
                  {customer.vorname && customer.nachname 
                    ? `${customer.vorname} ${customer.nachname}` 
                    : customer.email
                  }
                </div>
                <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '2px' }}>
                  Beraternummer: {customer.beraternummer} | Mandantennummer: {customer.mandantennummer}
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* Abbrechen Button */}
        <button
          onClick={onCancel}
          style={{
            width: '100%',
            padding: '10px 16px',
            border: '1px solid #D1D5DB',
            borderRadius: '8px',
            backgroundColor: 'white',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151'
          }}
        >
          Abbrechen
        </button>
      </div>
    </div>
  );
};
